// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lA_fi","label":"styles_label__13eTF"};